import React, {Fragment} from "react";
import FilterBase from "./FilterBase";
import {Col, Container, Form, Row} from "react-bootstrap";
import SelectFilter from "../select/SelectFilter";
import SelectSearch from "../select/SelectSearch";
import InputSearch from "../forms/InputSearch";
import classNames from 'classnames';

import * as PropTypes from "prop-types";
import requiredIf from 'react-required-if';

import '../../../assets/sass/global/filters/filter-toolbar.scss';

// TODO: Make it dynamic;
class FilterToolbar extends FilterBase {
    renderContent = () => {
        const {size, color, filters: _filters} = this.props;
        const filters = _filters.map(filter => ({...filter, size: size, color: color}));

        return (
            <div className="filter-toolbar">
                <Form onSubmit={this.handleSubmit} className="toolbar">
                    <Form.Row className="row form">
                        {filters.map((filter, index) => {
                            const columnProps = {span: filter.span, align: filter.align};

                            return this.wrapWithinColumn(
                                this.renderFilter(filter, index),
                                columnProps
                            );
                        })}
                    </Form.Row>
                </Form>
            </div>
        );
    };

    wrapWithinLeftRight = (leftComponents, rightComponents) => {
        const {left, right} = this.props;

        if (left && right) {
            return (
                <Container fluid={true}>
                    <Row>
                        <Col {...left}> {leftComponents} </Col>
                        <Col {...right}> {rightComponents} </Col>
                    </Row>
                </Container>
            );
        } else {
            return (
                <Fragment>
                    {leftComponents}
                    {rightComponents}
                </Fragment>
            );
        }
    };

    /**
     * Wraps the content within column.
     * @param component {React.ReactNode} The component witch wrapped within column.
     * @param props {{span: {xs: number|string|boolean, sm: number|string|boolean, md: number|string|boolean, lg: number|string|boolean, xl: number|string|boolean}, align: string}} The span and align props.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinColumn = (component, props) => {
        const {span, align} = props;
        const alignClass = align === 'right' ? 'ml-auto' : '';

        return (
            <Col className={classNames("filter", alignClass)} {...span} > {component} </Col>
        );
    };

    /**
     *
     * @param filter
     * @param index
     * @returns {*}
     */
    renderFilter = (filter, index) => {
        const {renderer, onChange} = filter;
        if (typeof renderer === 'function') {
            return renderer(filter, onChange, index);
        } else {
            const {placeholder, searchPlaceholder, name, options, withSearch, type, size, color, selected} = filter;
            const handleChange = (event) => this.handleChange(event, name, onChange);

            if (type === 'multiple-select') {
                // const defaultOption = (_defaultOption === undefined) ? options[0] : (typeof _defaultOption === 'number') ? options[_defaultOption] : _defaultOption;
                // TODO: pass defaultOption.

                if (withSearch) {
                    return (
                        <SelectSearch key={index} type={size} name={name} placeholder={placeholder} selected={selected} searchPlaceholder={searchPlaceholder} options={SelectSearch.options(options)} onDoneClick={({options}) => handleChange(options)}/>
                    );
                } else {
                    return (
                        <SelectFilter key={index} type={size} name={name} placeholder={placeholder} selected={selected} options={SelectFilter.options((options))} onDoneClick={({options}) => handleChange(options)}/>
                    );
                }
            } else if (type === 'search') {
                return (
                    <InputSearch name={name} size={size} color={color} placeHolder={placeholder} onChange={event => handleChange(event.target.value)}/>
                )
            }
        }
    };

    /**
     * Handle filter change.
     * @param value .
     * @param name {string} The filter name.
     * @param onFilterChange {function} The change event handler.
     */
    handleChange = (value, name, onFilterChange) => {
        const {onChange} = this.props;

        this.setState({
            [name]: value
        }, () => {

            if (typeof onFilterChange === 'function')
                onFilterChange(value);

            if (typeof onChange === 'function')
                onChange(this.values());
        });
    };

    /**
     * Returns filters values.
     * @returns {Readonly<S>} The filters values.
     */
    values = () => this.state;

    static propTypes = {
        filters: PropTypes.shape({
            // The display text witch appears on component.
            placeholder: PropTypes.string.isRequired,

            // The name of the input field.
            name: PropTypes.string.isRequired,

            // The type of the filter.
            type: PropTypes.oneOf(['multiple-select', 'search']).isRequired,

            // The select filter options.
            options: requiredIf(
                PropTypes.arrayOf(
                    PropTypes.shape({
                        // The unique key for option.
                        key: PropTypes.string,
                        // The label of the option.
                        label: PropTypes.string.isRequired,
                        // The value of the option.
                        value: PropTypes.string.isRequired,
                    },),
                ),
                props => props.type === 'multiple-select'
            ),
            defaultOption: PropTypes.oneOfType([
                // The index of the option in options array.
                PropTypes.number,
                // The full option object.
                PropTypes.shape({
                    // The unique key for option.
                    key: PropTypes.string,
                    // The label of the option.
                    label: PropTypes.string.isRequired,
                    // The value of the option.
                    value: PropTypes.string.isRequired,
                }),
            ]),

            // Determine if input filed has search box.
            withSearch: PropTypes.bool,

            // The color style of the filter.
            color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'toggle-active', 'toggle-inactive', 'dark-toggle-inactive', 'dark-toggle-inactive']),

            // The size of the filter.
            size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

            // The span of the filter column.
            span: PropTypes.shape({
                xs: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
                sm: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
                md: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
                lg: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
                xl: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
            }).isRequired,

            // The align of the filter.
            align: PropTypes.oneOf(['left', 'right']),

            // The renderer of the filter,
            // @param props {object} the filter props.
            // @param onChange {function} the onclick event.
            // @param index {integer} the index of the filter.
            renderer: PropTypes.func,

            // The onClick event handler.
            onClick: PropTypes.func,
        }).isRequired,

        // The size of the filters.
        size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

        // The color style of the filters.
        color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'toggle-active', 'toggle-inactive', 'dark-toggle-inactive', 'dark-toggle-inactive']),
    };

    static defaultProps = {
        filters: [],
        size: 'sm',
        color: 'primary',
    };
}

export default FilterToolbar;
